import Entity from './entity';
export default class Settings extends Entity<number> {
  whatsapp:string
  twitter: string;
  instagram: string;
  price: string;
}